import Swiper from 'swiper';
import { Pagination, Navigation, Thumbs } from 'swiper/modules';
import 'swiper/css';

document.addEventListener('DOMContentLoaded', () => {
    const galleryMainElement = document.querySelector(".gallery-main");
    const galleryThumbsElement = document.querySelector(".gallery-thumbs");

    if (galleryMainElement) {
        const slides = galleryMainElement.querySelectorAll('.swiper-slide');
        const hasMultipleSlides = slides.length > 1;
        const nextButton = document.querySelector('.slider-next');
        const prevButton = document.querySelector('.slider-prev');
        const paginationElement = document.querySelector('.slider-pagination');

        let galleryThumbs;

        // Initialize the thumbnail Swiper only if there are multiple slides
        if (galleryThumbsElement) {
            if (hasMultipleSlides) {
                galleryThumbs = new Swiper(".gallery-thumbs", {
                    spaceBetween: 10,
                    slidesPerView: 8,
                    freeMode: true,
                    watchSlidesProgress: true,
                });
            } else {
                // If there's only one slide, hide/remove the thumbnails
                galleryThumbsElement.style.display = "none";
            }
        }

        // Initialize the main gallery Swiper
        const galleryMain = new Swiper(".gallery-main", {
            modules: [Navigation, Pagination, Thumbs],
            spaceBetween: 10,
            cssMode: true,
            navigation: hasMultipleSlides ? {
                nextEl: '.slider-next',
                prevEl: '.slider-prev',
            } : false,
            pagination: hasMultipleSlides ? {
                el: ".slider-pagination",
                clickable: true
            } : false,
            thumbs: hasMultipleSlides ? {
                swiper: galleryThumbs,
            } : false,
        });

        // Hide navigation and pagination if only one slide exists
        if (!hasMultipleSlides) {
            if (nextButton) nextButton.style.display = 'none';
            if (prevButton) prevButton.style.display = 'none';
            if (paginationElement) paginationElement.style.display = 'none';
        }
    }
});
